import messages from '../constants/messages';
import parse from 'html-react-parser';

export const codeSuccess = 'FE-001';

export const getParamsFromLocation = location => {
  const regex = /[?&]([^=#]+)=([^&#]*)/g;
  const params = {};
  let match = regex.exec(location.search);

  while (match) {
    const [, param, value] = match;

    params[param] = value;
    match = regex.exec(location.search);
  }

  return params;
};

export const getAuthCode = input => {
  const data = {
    assinante: input.subscriber,
    proximaRecarga: input.nextRecharge,
    documento: input.document,
    canal: input.channel,
  };

  return fetch(`${process.env.REACT_APP_API_URL}/auth`, {
    method: 'POST',
    headers: {
      Authorization: `apiKey ${process.env.REACT_APP_API_KEY}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then(response => response.json())
    .then(data => data.authCode);
};

export const getMessageFromCode = code => {
  const codeNumber = code.slice(-4);

  if (messages[codeNumber]) {
    return { title: 'Ops', text: messages[codeNumber] };
  } else {
    return {
      title: 'Ops',
      text: `Falha ao processar seu pedido (código: ${codeNumber}.`,
    };
  }
};

export const currencyFilter = value => {
  const formatedValue = Number(value / 100).toFixed(2);

  return parse(`<span>R$</span>${String(formatedValue).replace('.', ',')}`);
};

export const validateCardForm = (card, propName) => {
  let validated = true;
  let error = {};
  const isBlurValidation = propName;

  Object.entries(card).forEach(async ([prop, value]) => {
    let message = '';
    let trimValue = value ? value.replace(/[^\d]/g, '') : '';
    propName = isBlurValidation ? propName : prop;

    if (propName === prop) {
      if (!trimValue) {
        validated = false;
        message = 'Este campo é obrigatório.';
      }

      if (prop === 'number' && trimValue > 0 && trimValue.length < 16) {
        validated = false;
        message = 'Número do cartão inválido.';
      }

      if (prop === 'cvv' && trimValue.length > 0 && trimValue.length < 3) {
        validated = false;
        message = 'Código inválido.';
      }

      if (prop === 'validity') {
        let validationResult = validateDate(trimValue);
        validated = validationResult.validated;
        message = validationResult.message;
      }
    }

    error = {
      ...error,
      [prop]: message,
    };
  });

  return { validated, error };
};

const validateDate = date => {
  let result = { validated: true, message: '' };

  if (date.length > 0 && date.length < 3) {
    result.validated = false;
    result.message = 'Data inválida.';
  } else {
    let month = date.substring(0, 2);
    let year = date.substring(2);
    let currentYear = new Date()
      .getFullYear()
      .toString()
      .substring(2);

    if (month === 0 || month > 12 || year < parseInt(currentYear)) {
      result.validated = false;
      result.message = 'Data inválida.';
    }
  }

  return result;
};

export const getExceptionResponse = e => {
  if (process.env.NODE_ENV === 'test') {
    return { data: { code: 'CO-5000' } };
  } else {
    return e.response;
  }
};

export const isProduction = () => {
  return process.env.REACT_APP_ENVIRONMENT === 'production';
};
